import { replaceTokens } from '@sleepstation/utils'
import { always, prop } from 'ramda'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

export const formatWithTemplateOrAlwaysNull = (template) =>
  template ? replaceTokens(template) : always(null)

export const formatFirstName = prop(`name`)

export const formatFullName = replaceTokens(`#{name} #{surname}`)

export const formatFirstNameAndProfession = ({ name, profession }) =>
  `${name}, ${profession}`

export const formatContext = prop(`context`)

export const formatNameAgeLocation = ({ name, age, location }) =>
  `${name}${age ? ` ${age},` : ``} from ${location}`

export const formatAgeLocation = ({ age, location }) =>
  `${age}, from ${location}`

export const formatDefault = ({ name, age, location, profession }) => {
  const secondaryInfo = profession || age
  return `${name}, ${
    secondaryInfo ? ` ${secondaryInfo} ` : ``
  } from ${location}`
}
